import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountingService } from 'src/app/services/accounting/accounting.service';
import * as moment  from 'moment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-ledger-print',
  templateUrl: './ledger-print.component.html',
  styleUrls: ['./ledger-print.component.css']
})
export class LedgerPrintComponent implements OnInit {
  constructor(private activatedRoute:ActivatedRoute,private accService:AccountingService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { 
    this.activatedRoute.queryParams.subscribe(params => {
     
      this.PaymentModelSearch.FromDate = params['FromDate'];
      this.PaymentModelSearch.ToDate = params['ToDate'];
      this.PaymentModelSearch.AccID = params['AccID'];
      this.GetLedger();
  });
  }
  PaymentModelSearch = {
    AccID: 0,
    FromDate:  moment(Date.now()).format("DD-MMM-YYYY"),
    ToDate:  moment(Date.now()).format("DD-MMM-YYYY"),
    Print:""
};


SearchBankAccName = '';
ClearSearch  () {
    this.PaymentModelSearch.AccID = 0;
    this.PaymentModelSearch.FromDate = moment(Date.now()).format("DD-MMM-YYYY");
    this.PaymentModelSearch.ToDate = moment(Date.now()).format("DD-MMM-YYYY");
    this.SearchBankAccName = '';
};
loadingSearch = false;
LedgerList:any;
AccDetails:any;
AccDetails1:any;
OpeningBalance= 0;
PreviousBalance=0;
BranchDetails:any;
GetLedger  () {

    this.loadingSearch = true;
    this.spinnerService.show();
    this.accService.GetLedger(JSON.stringify(this.PaymentModelSearch)).subscribe( (response)=> {
      this.LedgerList = response.LedgerList;
      this.search( this.LedgerList);
      this.AccDetails = response.AccDetails;
      this.BranchDetails = response.BranchDetails;
      this.AccDetails1 = response.LedgerList[0];
      this.OpeningBalance = 0;
      for (var i = 0; i < this.LedgerList.length; i++) {

          this.PreviousBalance = this.LedgerList[i].VcAccountList[0].OpeningBalance;
         
          this.OpeningBalance = this.LedgerList[i].VcAccountList[0].OpeningBalance;
        
          for (var j = 0; j < this.LedgerList[i].VcAccountList.length; j++) {
           
              if (this.PreviousBalance >= 0) {
                  this.PreviousBalance = this.PreviousBalance - this.LedgerList[i].VcAccountList[j].DebitAmt +this.LedgerList[i].VcAccountList[j].CreditAmt;
              }
              else {
                  this.PreviousBalance = this.PreviousBalance -this.LedgerList[i].VcAccountList[j].DebitAmt +this.LedgerList[i].VcAccountList[j].CreditAmt;
              }
              //this.PreviousBalance = this.PreviousBalance + this.LedgerList[i].VcAccountList[j].DebitAmt - this.LedgerList[i].VcAccountList[j].CreditAmt;
              this.LedgerList[i].VcAccountList[j].OpeningBalance = this.PreviousBalance;


          }
          if (this.OpeningBalance>0) {
              this.LedgerList[i].TotalOpeningAmt = this.OpeningBalance + this.LedgerList[i].TotalDebitAmt - this.LedgerList[i].TotalCreditAmt;
          }
          else{
          this.LedgerList[i].TotalOpeningAmt = this.OpeningBalance - this.LedgerList[i].TotalDebitAmt + this.LedgerList[i].TotalCreditAmt;
      } 
      }
      
        setTimeout( ()=>{
          this.spinnerService.hide();
            this.loadingSearch = false;
          
        }, 10);
    });
};
itemsPerPage=30;
  pagedItems = [];
 search(itemlist){
   
  for (var i = 0; i < itemlist.length; i++) {
      if (i % this.itemsPerPage === 0) {
        this.pagedItems[Math.floor(i / this.itemsPerPage)] = [itemlist[i]];
      } else {
        this.pagedItems[Math.floor(i / this.itemsPerPage)].push(itemlist[i]);
      }
  }

 }
 PrintDate:any;
ngOnInit() {
  this.PrintDate = new Date();
}
print(){
  window.print();
}
}
